import React from 'react';
import {
    Col,
    Form,
    Button,
    FormGroup,
    FormLabel,
    FormControl,
} from 'react-bootstrap';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Card, Captcha, LoaderBtn } from 'components';
import { RegExpConst } from '_helpers';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

const ResetPasswordContainer = ({
    apiError, onPush, sendEmailForResetPassword, clearErrors,
}: Props) => {
    const [email, setEmail] = React.useState('');
    const [emailValid, setEmailValid] = React.useState(true);
    const [captcha, setCaptcha] = React.useState('');
    const [captchaValid, setCaptchaValid] = React.useState(true);
    const [successSubmit, setSuccessSubmit] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        clearErrors();
    }, []);

    const doValidate = (): boolean => {
        const isEmailValid = RegExpConst.EMAIL.test(email);
        const isCaptchaValid = apiError && apiError.failures && apiError.failures.captcha ? captcha.length === 4 : true;

        setEmailValid(isEmailValid);
        setCaptchaValid(isCaptchaValid);

        return isEmailValid && isCaptchaValid;
    };

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!doValidate()) return;

        setProcessing(true);
        const res = await sendEmailForResetPassword({ email, captcha });
        setProcessing(false);

        setCaptcha('');

        if (res) {
            setSuccessSubmit(true);
        }
    };

    return (
        <Col className="auth-forms--container">
            <Form onSubmit={onSubmit}>
                <Card
                  title="Сброс пароля"
                  ftTextCenter
                  apiError={apiError}
                  legend={(
                        <>
                            {!successSubmit && (
                                <LoaderBtn disabled={processing} loading={processing} variant="primary" type="submit">
                                    Продолжить
                                </LoaderBtn>
                            )}
                            <Button variant="outline-secondary" onClick={() => onPush('/')}>
                                Назад
                            </Button>
                        </>
                    )}
                >
                    {!successSubmit ? (
                        <>
                            <div className="sub-title">
                                для восстановления доступа в
                                личный кабинет
                            </div>
                            <FormGroup className="phone-form--container" data-test-phone-group>
                                <FormLabel>Укажите ваш email</FormLabel>
                                <FormControl
                                  autoFocus
                                  name="email"
                                  value={email}
                                  onChange={(e: React.FormEvent<any>) => setEmail((e.target as HTMLInputElement).value)}
                                  isInvalid={!emailValid || !!(apiError && apiError.failures && apiError.failures.email)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {!emailValid ? 'Неверный формат email' : apiError && apiError.failures && apiError.failures.email}
                                </Form.Control.Feedback>
                            </FormGroup>
                            <Captcha captcha={captcha} captchaValid={captchaValid} apiError={apiError} setCaptcha={setCaptcha} />
                            <Form.Control.Feedback className="d-block" type="invalid">
                                {apiError && !(apiError.failures && apiError.failures.email) && apiError.message}
                            </Form.Control.Feedback>
                        </>
                    )
                        : (
                            <div className="sub-title">
                                Ссылка для восстановления пароля успешно отправлена на почту!
                            </div>
                        )}
                </Card>
            </Form>
        </Col>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    clearErrors: dispatch.errors.clean,
    sendEmailForResetPassword:dispatch.auth.sendEmailForResetPasswordAsync,
    onPush: (key: string) => dispatch(push(key)),
});

export default connect(mapState, mapDispatch)(ResetPasswordContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
